import { Component } from '@angular/core';

@Component({
  selector: 'app-datadeletion',
  templateUrl: './datadeletion.component.html',
  styleUrls: ['./datadeletion.component.scss']
})
export class DatadeletionComponent {
 appName = 'ClariChat.ai';
  websiteUrl = 'https://clarichat.ai';
  contactEmail = 'alisuperprofessionalemail@gmail.com';
  estimatedProcessingTime = '7 business days';
}
